import React from 'react';
import './Tags.scss';
import { renderTags } from '../Card/util/renderTags';

const Tags = ({ tags }) => {
  return <div className="c-tags">{renderTags(tags)}</div>;
};

export default Tags;
